import { render } from "./AccountCreationPage.vue?vue&type=template&id=706564cf&scoped=true"
import script from "./AccountCreationPage.vue?vue&type=script&lang=js"
export * from "./AccountCreationPage.vue?vue&type=script&lang=js"

import "./AccountCreationPage.vue?vue&type=style&index=0&id=706564cf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-706564cf"]])

export default __exports__